import { MONTH_NAMES } from '../utils/constants';
/**
 * To render parsed date & time on shipment each card.
 * @param {string} fromTime API appointment-from date & time value.
 * @param {string} toTime API appointment-to date & time value.
 * @returns {object} formated date & time to render on UI.
 */
export default function getTime(fromTime: string, toTime: string) {
  let disPlayTime = '';
  const _src: any = formatDate(fromTime) || {};
  const _dst: any = formatDate(toTime) || {};
  const _toMonth = getSourceMonth(_src,_dst);
  const _toDay =  getSourceToDay(_src,_dst);
  const _toTime = _dst.time;
  let _to = '';
  if (Object.keys(_src).length) {
    disPlayTime = `${_src.month} ${_src.day} ${_src.time}`;
  }

  if ((_toMonth && !_toDay) || (!_toMonth && _toDay) || (_toMonth && _toDay)) {
    _to = `${_to} ${_dst.month} ${_dst.day}`;
  }
  if (_toTime) {
    _to = `${_to} ${_toTime}`;
  }
  if (_to) {
    disPlayTime = `${disPlayTime} ${disPlayTime && _to ? ' -' :''}${_to}`;
  }
  return disPlayTime;
}
const getSourceMonth = (_src:any,_dst:any)=>{
  return _src.month === _dst.month ? '' : _dst.month;
}
const getSourceToDay = (_src:any,_dst:any)=>{
  return _src.day === _dst.day ? '' : _dst.day;
}

/**
 * To get parsed date & time.
 * @param {*} date date format.
 * @returns {object} date object.
 */
const formatDate = (date: any) => {
  if (!/\d{4}-[0-9]\d-[0-9]\dT[0-9]\d:[0-9]\d/.test(date)) {
    return null;
  }
  date = date.split('T');
  const dateString = date[0];
  let timeString = date[1];
  const _date = dateString.split('-');
  const _year = parseInt(_date[0]);
  const _month = MONTH_NAMES[parseInt(_date[1]) - 1];
  const _day = parseInt(_date[2]);
  timeString = timeString && timeString.split(':');
  let _hours = timeString.length ? timeString[0] : '';
  let _min = timeString.length ? timeString[1] : '';
  if (_min && _min.indexOf('-') !== -1) {
    _min = _min.slice(0, _min.indexOf('-'));
  }
  const _AmOrPm = _hours >= 12 ? 'PM' : 'AM';
  _hours = _hours % 12 || 12;
  const _time = `${_hours}:${_min}${_AmOrPm}`;
  return { year: _year, month: _month, day: _day, time: _time };
};
